import "core-js/modules/es.array.push.js";
import { computed, defineComponent, nextTick, ref, watch } from "vue";
import { useStore } from "vuex";
import AWelcome from "@/components/AiChat/AWelcome";
import AiMessage from "@/components/AiChat/AiMessage";
import useChat from "@/hooks/useChat";
import { saveGroup } from "@/service/chat";
import axios from "axios";
export default defineComponent({
  data() {
    return {
      mediaRecorder: null,
      isRecording: false,
      buttonLabel: '语音输入',
      chunks: []
    };
  },
  name: "Ai-Chat",
  methods: {
    removeImage() {
      this.img_url = null; // 或其他适合的逻辑来移除图片
      this.$refs.fileInput.value = ''; // 清除文件输入元素的值
    },

    onFileSelected(event) {
      //获取用户选择的文件
      const file = event.target.files[0];
      console.log(file);
      //创建一个FormData对象，用于封装需要上传的文件数据
      const formData = new FormData();
      //将文件添加到FormData对象中
      formData.append("file", file);

      //使用这个来请求接口
      fetch("/web.php/chat/upload", {
        method: "POST",
        body: formData
      }).then(response => response.json()).then(data => {
        console.log('Response:', data);
        if (data.errno === 0) {
          // 上传成功
          console.log('上传成功');
          console.log(data.data);
          this.img_url = data.data; // 正确访问 img_url
          this.text = '这个图片里面说了什么?'; // 正确访问 img_url
        } else {
          // 上传失败
          alert("上传失败" + data.message);
          console.log('上传失败');
        }
      }).catch(error => {
        console.error('Upload Error:', error);
      });
    },
    onImageUpload(event) {
      //弹窗文件选择框
      this.$refs.fileInput.click();
    },
    async onVoiceInput() {
      if (!this.mediaRecorder) {
        navigator.mediaDevices.getUserMedia({
          audio: true
        }).then(stream => {
          // 在这里调用 setupMediaRecorder
          this.setupMediaRecorder(stream);
          this.chunks = [];
          this.mediaRecorder.start(100);
          this.isRecording = true;
          console.log('开始录音');
          this.buttonLabel = '录音中..';
        }).catch(err => {
          console.error('获取麦克风权限失败:', err);
        });
      } else if (this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
        console.log('停止录音');
        this.buttonLabel = '语音输入';
      } else {
        this.chunks = [];
        this.mediaRecorder.start(100);
        //清空录音数据

        this.isRecording = true;
        console.log('开始录音');
        this.buttonLabel = '录音中..';
      }
    },
    setupMediaRecorder(stream) {
      console.log('aaa');
      this.mediaRecorder = new MediaRecorder(stream);
      this.mediaRecorder.ondataavailable = e => {
        console.log('录音数据可用');
        this.chunks.push(e.data);
      };
      this.mediaRecorder.onstop = e => {
        const blob = new Blob(this.chunks, {
          'type': 'audio/ogg; codecs=opus'
        });
        console.log(blob);
        const audioURL = URL.createObjectURL(blob);
        //读取Base64录音数据

        console.log(audioURL);
        //调用腾讯云语音识别接口
        this.sendVoice(blob);

        // 这里可以处理 audioURL，例如保存或上传
      };
    },

    async sendVoice(yinping_data) {
      const formData = new FormData();
      formData.append('yinping_data', yinping_data);
      // 上传到腾讯云
      //使用这个来请求接口
      fetch("/web.php/chat/yuyin_shibie", {
        method: "POST",
        body: formData
      }).then(response => response.json()).then(data => {
        console.log('Response:', data);
        if (data.errno === 0) {
          // 上传成功
          console.log(data.data);
          this.text = data.data;
        } else {
          // 上传失败
          alert("上传失败" + data.message);
          console.log('识别失败');
        }
      }).catch(error => {
        console.error('识别失败 Error:', error);
      });
    },
    handleEnterKeyDown(event) {
      if (event.shiftKey) {
        // 如果同时按下 Shift，则允许默认行为（换行）
        this.shiftPressed = true;
      }
    },
    handleEnterKeyUp() {
      if (!this.shiftPressed) {
        // 如果没有按下 Shift，则发送消息
        this.send();
      }
      // 重置标志
      this.shiftPressed = false;
    }
  },
  components: {
    AWelcome,
    AiMessage
  },
  setup() {
    const store = useStore();
    const text = ref();
    const luiyn_code = ref(false);
    const scrollbar = ref();
    const {
      writing,
      answer,
      getAnswer,
      img_url
    } = useChat();
    const history = computed(() => {
      return store.state.currentChatMsgHistory || [];
    });
    const currentSession = computed(() => {
      return store.state.currentSession;
    });
    const historyLoading = computed(() => {
      return store.state.historyLoading;
    });
    async function scrollToBottom() {
      await nextTick();
      scrollbar.value.setScrollTop(999999);
    }
    watch([history, writing], ([v, w]) => {
      if (v.length || w) {
        scrollToBottom();
      }
      if (w) {
        text.value = "";
      }
    });
    function autoTitle(title) {
      return saveGroup({
        id: currentSession.value,
        title
      }).then(() => {
        let oldSession = store.state.sessions;
        oldSession.find(item => item.id === currentSession.value).title = title;
        store.commit("SET_SESSIONS", [...oldSession]);
      });
    }
    async function send() {
      if (!text.value) return;
      if (history.value.length === 0) {
        await autoTitle(text.value);
      }
      store.commit("SET_CURRENT_CHAT_MSG", [...history.value, {
        user: "我",
        message: text.value
      }]);
      await scrollToBottom();
      await getAnswer(text.value, scrollToBottom);
      store.commit("SET_CURRENT_CHAT_MSG", [...history.value, {
        user: "AI",
        message: answer.value
      }]);
      await scrollToBottom();
      answer.value = "";
    }
    return {
      history,
      text,
      historyLoading,
      send,
      writing,
      answer,
      scrollbar,
      img_url,
      luiyn_code
    };
  }
});